import { Organisation, TradingEntityWithAlias, ClearingHouse, Sponsor } from 'api'
import { isNil } from 'lodash-es'
import { TradingEntityWithAliasHelper } from 'model'
import { Translation, Locale } from 'locale'

export const getUserAndOrganisationTicketInfo = (
  ownOrder: boolean,
  initiatorOrganisation: Organisation | null,
  responderOrganisation: Organisation | null,
  initiatorUserInitials: string | null,
  responderUserInitials: string | null
) => {
  const lastUpdatedUserInitials = ownOrder ? responderUserInitials : initiatorUserInitials
  const lastUpdatedUserInitialsStr = isNil(lastUpdatedUserInitials) ? '' : `${lastUpdatedUserInitials} @ `
  const organisation = ownOrder
    ? isNil(responderOrganisation)
      ? ''
      : `${responderOrganisation.legalName}`
    : isNil(initiatorOrganisation)
    ? ''
    : `${initiatorOrganisation.legalName}`

  return `${lastUpdatedUserInitialsStr}${organisation}`
}

export const getInitiatorTradingEntityTicketInfo = (ownOrder: boolean, initiatorTradingEntity: TradingEntityWithAlias | null) => {
  if (isNil(initiatorTradingEntity)) {
    return ''
  }

  return ownOrder ? ` ${initiatorTradingEntity.publishedName}` : ` ${TradingEntityWithAliasHelper.getName(initiatorTradingEntity)}`
}

export const getClearingTicketInfo = (
  clearingHouse: ClearingHouse | null,
  ownOrder: boolean,
  sponsor: Sponsor | null,
  counterpartySponsor: Sponsor | null
) => {
  if (isNil(clearingHouse)) {
    return ''
  }

  const clearingSponsor = ownOrder ? sponsor : counterpartySponsor

  const sponsorSuffix = isNil(clearingSponsor) ? '' : ` (${Locale.translate(Translation.TC_SPONSORED_SUFFIX)})`
  return `, ${clearingHouse.publishedName}${sponsorSuffix}`
}
